import "../../Components/Page/Page.css";
import "../../Pages/Investment/Investment.css";

import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";

const DeRisking: React.FC = () => {
  return (
    <div className="sectionContainer">
      <SecHeader title="De-Risking" />
      <SubSection isSplit={false}>
        <div className="inv-items">
          <div className="inv-item">
            <h4 className="inv-item-title">Tariff-Proofing</h4>
            <ul>
              <li>ICE GEMS is "Tariff-Proof" since we encourage producing new engines and parts in all countries</li>
              <li>We are U.S. made, owned, and IP-controlled, with 100% in-house product production</li>
              <li>We are predicted to give shareholders their investment amounts or more in dividends in the next 5–6 years</li>
            </ul>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">Policy-Proofing</h4>
            <ul>
              <li>ICE GEMS is "Policy-Proof" since ELF-Tech improves energy resilience, jobs, environmental impacts, climates, manufacturing, tech leadership, and public policies</li>
            </ul>
          </div>
          <div className="inv-item">
            <h4 className="inv-item-title">Future-Proofing</h4>
            <ul>
              <li>ELF-Tech engines can use existing fuels more cleanly and efficiently</li>
              <li>They can be used to retrofit existing vehicles, saving jobs and factories, complying with short-term policies</li>
              <li>As new Net-0-CO2 fuels are discovered, ELF-Tech offers the best ways to improve environmental impacts and climate — ICE GEMS is "Future-Proof" for the next 50 years</li>
            </ul>
          </div>
        </div>
      </SubSection>
    </div>
  );
};

export default DeRisking;
